export default __webpack_public_path__ + "static/media/55912408_2093634310725981_2682881746994724864_n.5d89a16e.jpg";